import { render, staticRenderFns } from "./activityPrice.vue?vue&type=template&id=1b9a17dc&scoped=true&"
import script from "./activityPrice.vue?vue&type=script&lang=js&"
export * from "./activityPrice.vue?vue&type=script&lang=js&"
import style0 from "./activityPrice.vue?vue&type=style&index=0&id=1b9a17dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9a17dc",
  null
  
)

export default component.exports